<template>
  <div class="admin-account-list-page page-content">
    <el-row class="page-header -with-search-bar" type="flex" justify="space-between">
      <el-col :span="7">
        <h2 class="page-title">รายชื่อผู้ใช้งาน</h2>
      </el-col>
      <el-col :span="11">
        <el-input placeholder="ค้นหารายชื่อผู้ใช้งาน (อีเมล, ชื่อ หรือ รหัสพนักงาน)" v-model="searchTerm" class="input-with-select">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </el-col>
      <el-col :span="5">
        <el-button type="primary"
          class="search-button"
          v-if="!isViewerRole"
          @click.prevent="createAdminAccount">
          <span class="text">เพิ่มผู้ใช้งาน</span> <i class="el-icon-plus el-icon-right"></i>
        </el-button>
      </el-col>
    </el-row>
    <div class="admin-list-table">
      <el-table
        :data="adminListData"
        :default-sort = "{prop: 'email', order: 'ascending'}"
        style="width: 100%">
        <el-table-column
          prop="email"
          label="อีเมล"
          sortable
          class-name="no-wrap"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="name"
          label="ชื่อ"
          sortable
          class-name="no-wrap"
          min-width="130">
        </el-table-column>
        <el-table-column
          prop="tel"
          label="โทรศัพท์"
          sortable
          :formatter="telFormatter"
          width="140">
        </el-table-column>
        <el-table-column
          prop="scb_employee_id"
          label="รหัสพนักงาน"
          sortable
          width="140">
        </el-table-column>
        <!--<el-table-column
          prop="created_at"
          label="วันที่สร้าง"
          width="100"
          :formatter="dateFormatter">
        </el-table-column>
        <el-table-column
          prop="update_at"
          label="วันที่แก้ไขล่าสุด"
          width="100"
          :formatter="dateFormatter">
        </el-table-column>-->
        <el-table-column
          prop="role"
          label="หน้าที่"
          sortable
          :formatter="roleFormatter"
          width="100">
        </el-table-column>
        <el-table-column
          prop="status"
          label="สถานะ"
          width="100"
          :formatter="statusFormatter">
          <template slot-scope="scope">
            <el-tag
              :type="statusTypeFormatter(scope.row)"
              close-transition>{{statusFormatter(scope.row)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="description"
          label="รายละเอียด"
          min-width="150"
          class-name="desc-col no-wrap">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="ตัวเลือก"
          header-align="center"
          align="center"
          class-name="action-col"
          width="80">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              size="mini"
              @click.prevent="handleEdit(scope.$index, scope.row)"
              class="action-btn">แก้ไข</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import moment from 'moment-timezone';
  // import store from '@/store';
  import { createMask } from 'imask';
  // import lunr from 'lunr';

  /* require('lunr-languages/lunr.stemmer.support')(lunr);
  require('lunr-languages/lunr.multi')(lunr);
  require('@/i18n/lunr.th')(lunr); */

  /**
   * Admin Account List view
   */
  const AdminAccountListView = {
    name: 'admin-account-list',
    data() {
      return {
        isSubmitting: false,
        searchTerm: '',
        indexer: null,
        mask: {
          tel: {
            mask: [
              { mask: '{02}-000-0000' },
              { mask: '{0}00-000-000' },
              { mask: '{0}00-000-0000' },
            ],
          },
        },
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.idToken;
      },
      isViewerRole() {
        return this.$store.getters.isViewerRole;
      },
      adminList() {
        return this.$store.getters.adminList;
      },
      adminListData() {
        // return this.$store.getters.adminList;
        /* if (this.indexer && this.searchTerm.trim() !== '') {
          const res = this.indexer.search(this.searchTerm.trim().toLowerCase());
          // build result list
          const refs = res.map(item => parseInt(item.ref, 10));
          return this.adminList.filter(item => refs.indexOf(item.id) !== -1);
        } */
        const q = this.searchTerm.trim().toLowerCase();
        if (q !== '') {
          return this.adminList.filter((item) => {
            const name = item.name.trim().toLowerCase();
            const email = item.email.trim().toLowerCase();
            const emp = item.scb_employee_id.toString().trim().toLowerCase();
            return name.indexOf(q) !== -1 ||
              email.indexOf(q) !== -1 ||
              emp.indexOf(q) !== -1;
          });
        }
        return this.adminList;
      },
    },
    methods: {
      createAdminAccount() {
        this.$router.push({ name: 'AdminAccountCreate' });
      },
      handleEdit(index, row) {
        this.$router.push({
          name: 'AdminAccountEdit',
          params: {
            adminId: row.id,
          },
        });
      },
      roleFormatter(row) {
        if (row.role) {
          return row.role.toUpperCase() === 'ADMIN' ? 'Admin' : 'Viewer';
        }
        return 'Viewer';
      },
      dateFormatter(row, column, cellValue) {
        const date = moment(cellValue).tz(process.env.DEFAULT_TZ);
        if (date.isValid()) {
          return date.format('ll');
        }
        return '-';
      },
      statusFormatter(row) {
        let status = 'Disabled';
        if (row.status === 'blocked') {
          status = 'Blocked';
        } else if (row.status === 'active') {
          status = 'Enabled';
        }
        return status;
      },
      statusTypeFormatter(row) {
        let type = 'info';
        if (row.status === 'blocked') {
          type = 'danger';
        } else if (row.status === 'active') {
          type = 'success';
        }
        return type;
      },
      setIndexer(indexer) {
        this.indexer = indexer;
      },
      telFormatter(row, column, cellValue) {
        /* if (cellValue) {
          return this.maskFormatter(cellValue, this.mask.tel);
        }
        return '-'; */
        return cellValue || '-';
      },
      maskFormatter(val, maskOptions) {
        const mask = createMask(maskOptions);
        if (val) {
          return mask.resolve(val.toString());
        }
        return '';
      },
    },
    // Handle Routing
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        // Fetch data
        vm.$store.dispatch('START_CONTENT_LOADING');
        vm.$store.dispatch('GET_ADMIN_USER_LIST').then(() => {
          vm.$store.dispatch('STOP_CONTENT_LOADING');
        }).catch((err) => {
          vm.$store.dispatch('STOP_CONTENT_LOADING');
          vm.$store.dispatch('ADD_ERROR_FLASH', err);
        });
        /* vm.setIndexer(lunr((builder) => {
          builder.use(lunr.multiLanguage('en', 'th'));
          builder.field('email');
          builder.field('name');
          builder.field('description');

          vm.adminList.forEach((item) => {
            const indexItem = JSON.parse(JSON.stringify(item));
            builder.add(indexItem);
          });
        })); */
      });
    },
    // when route changes and this component is already rendered,
    // the logic will be slightly different.
    /* beforeRouteUpdate(to, from, next) {
      // Fetch data
      store.dispatch('START_CONTENT_LOADING');
      store.dispatch('GET_ADMIN_USER_LIST').then(() => {
        store.dispatch('STOP_CONTENT_LOADING');
      }).catch((err) => {
        store.dispatch('STOP_CONTENT_LOADING');
        store.dispatch('ADD_ERROR_FLASH', err);
      });
      next();
    }, */
  };
  export default AdminAccountListView;
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/auth/admin-account-list.vue